import { useQuery } from '@tanstack/react-query'
import { api } from './client'

// v29 Phase C — Dashboard-Recommendations Hook

export type RecommendationSeverity = 'high' | 'medium' | 'low'

export interface Recommendation {
  id: string
  severity: RecommendationSeverity
  title: string
  body: string
  count?: number
  actionLink: string
  actionLabel: string
}

export interface DashboardRecommendationsData {
  recommendations: Recommendation[]
  generatedAt: string
}

export function useDashboardRecommendations() {
  return useQuery({
    queryKey: ['recommendations', 'dashboard'],
    queryFn: () => api.get<DashboardRecommendationsData>('/recommendations/dashboard/'),
    refetchInterval: 60_000, // 1 min
    staleTime: 30_000,
  })
}
